module.exports = __webpack_public_path__ + "media/monsterMagic2.6893c935.wav";